<ng-container *transloco="let t">
  <app-loader [loading]="loading"></app-loader>

  <ng-container *ngIf="mode === FormMode.Edit">
    <form *ngIf="loading === false" (submit)="onSubmit()" novalidate>

      <p-messages></p-messages>

      <app-move-order-data
        [form]="form"
        [order]="order"
        [options]="options"
        [locations]="movingData?.locations"
        (changed)="onDataChanged($event)"
        #data
      ></app-move-order-data>

      <app-order-detail-participants
        [form]="form"
        [appointments]="movingData?.appointments"
        [userLocations]="movingData?.user_locations"
        [settings]="movingData?.settings"
        [options]="options"
        [order]="order"
        [texts]="[]"
        [mode]="mode"
        [move]="true"
        [inEdit]="true"
        [submitting]="submitting"
        [movingDate]="movingDate"
        [movingLocation]="movingLocation"
        (sendInvitation)="sendInvitation($event)"
        #participants
      >
      </app-order-detail-participants>

      <div class="p-grid" [ngClass]="{'p-mb-4': suggestionsVisible}">
        <div class="p-col-6">
          <button pButton type="button" [label]="t((suggestionsVisible) ? 'common.labels.hide_suggestions' : 'common.labels.show_suggestions')" (click)="onToggleSuggestions()" class="p-button-sm p-button-outlined p-button-secondary"></button>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons
            [submitting]="submitting"
            [submitLabel]="t('common.ok')"
            [disabled]="isSendDisabled()"
            (cancelled)="onCancel()"
          ></app-form-buttons>
        </div>
      </div>

      <app-move-order-suggestions
        [order]="order"
        [options]="options"
        [locations]="movingData?.locations"
        [visible]="suggestionsVisible"
        [movingDate]="movingDate"
        [movingLocation]="movingLocation"
        (selected)="onSuggestionSelected($event)"
      ></app-move-order-suggestions>

    </form>
  </ng-container>

  <ng-container *ngIf="mode === FormMode.Success">

    <p-card>

      <p>{{ t('move_order.messages.success') }}</p>

    </p-card>

    <div class="p-text-right p-mt-4">
      <button pButton type="button" [label]="t('common.labels.close')" (click)="onCancel()" class="p-button-sm p-button-success"></button>
    </div>

  </ng-container>

</ng-container>
